function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

var timer;
var remaining = 30;
var time;
function initCountdown() {
  if (!document.getElementById('scoreboard_update_countdown')) {
    return;
  }
  const convertToPersianDigits = (num) => {
    return new String(num).replace(/[0123456789]/g, (d) => {
      return '۰۱۲۳۴۵۶۷۸۹'[d];
    });
  };
  clearInterval(timer);
  time = remaining;
  timer = setInterval(function () {
    time--;

    document.getElementById('scoreboard_update_countdown').innerText =
      convertToPersianDigits(time);
    if (time <= 0) {
      clearInterval(timer);
    }
  }, 1000);
}

const initCountdownDebounced = debounce(() => initCountdown());

Livewire.hook('component.init', ({ component, cleanup }) => {
  if (
    component.name === 'code-battle.scoreboard' ||
    component.name === 'code-battle.full-scoreboard'
  ) {
    initCountdownDebounced();
  }
});

Livewire.hook('morph.updated', ({ component, el }) => {
  if (
    component.name === 'code-battle.scoreboard' ||
    component.name === 'code-battle.full-scoreboard'
  ) {
    initCountdownDebounced();
  }
});

const p2e = (s) => s.replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));
